import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    floor: 'lowrise',
    floors: ['lowrise', 'midrise', 'highrise'],
    configurationLowRise: {
      zoneA: { id: '1', name: '1. Large Office + Meeting Room', image: '/images/layouts/6a1.png' },
      zoneB: { id: '1', name: '1. 18 Workstations', image: '/images/layouts/6b1.png' },
      zoneC: { id: '1', name: '1. Additional Workstations', image: '/images/layouts/6c1.png' },
    },
    configurationMidRise: {
      zoneA: { id: '1', name: '1. Large Office + Meeting Room', image: '/images/layouts/16a1.png' },
      zoneB: { id: '1', name: '1. Seating + Workstations', image: '/images/layouts/16b1.png' },
    },
    configurationHighRise: {
      zoneA: { id: '1', name: '1. Large Office, Medium Office, Reception With 2 Workstations', image: '/images/layouts/21a1.png' },
    },
    configurations: {
      lowrise: {
        zoneA: [
          { id: '1', name: '1. Large Office + Meeting Room', image: '/images/layouts/6a1.png' },
          { id: '2', name: '2. Large, Medium and Small Office', image: '/images/layouts/6a2.png' },
          { id: '3', name: '3. 2 Medium Offices + Meeting Room', image: '/images/layouts/6a3.png' },
          { id: '4', name: '4. Medium Office and 3 Small Offices', image: '/images/layouts/6a4.png' }
        ],
        zoneB: [
          { id: '1', name: '1. 18 Workstations', image: '/images/layouts/6b1.png' },
          { id: '2', name: '2. 12 Workstations', image: '/images/layouts/6b2.png' },
          { id: '3', name: '3. 8 Workstations + Open Collaboration', image: '/images/layouts/6b3.png' }
        ],
        zoneC: [
          { id: '1', name: '1. Additional Workstations', image: '/images/layouts/6c1.png' },
          { id: '2', name: '2. Reception', image: '/images/layouts/6c2.png' },
          { id: '3', name: '3. Open Lounge', image: '/images/layouts/6c3.png' },
          { id: '4', name: '4. Enclosed Conference', image: '/images/layouts/6c4.png' },
        ]
      },
      midrise: {
        zoneA: [
          { id: '1', name: '1. Large Office + Meeting Room', image: '/images/layouts/16a1.png' },
          { id: '2', name: '2. Large, Medium and Small Office', image: '/images/layouts/16a2.png' },
          { id: '3', name: '3. 2 Medium Offices + Meeting Rooms', image: '/images/layouts/16a3.png' },
          { id: '4', name: '4. 1 Medium Office + 3 Small Offices', image: '/images/layouts/16a4.png' }
        ],
        zoneB: [
          { id: '1', name: '1. Seating + Workstations', image: '/images/layouts/16b1.png' },
          { id: '2', name: '2. Reception + Open Collaboration', image: '/images/layouts/16b2.png' },
        ],
      },
      highrise: {
        zoneA: [
          { id: '1', name: '1. Large Office, Medium Office, Reception With 2 Workstations', image: '/images/layouts/21a1.png' },
          { id: '2', name: '2. Large Office, Lounge and 3 Workstations', image: '/images/layouts/21a2.png' },
          { id: '3', name: '3. Large Office and 8 Workstations', image: '/images/layouts/21a3.png' },
        ],
      }
    },
    finish: 'light',
    finishes: ['light', 'dark'],
    floorSummaries: {
      highrise: 'Your High Rise Configuration. <br/> Floors 17-26 - 2,500 to 2,700 RSF. <br/> Floor 21 shown – 2,483 RSF',
      midrise: 'Your Mid Rise Configuration. <br/> Floors 7-16 - 3,000 to 3,800 RSF. <br/> Floor 16 shown – 3,051 RSF',
      lowrise: 'Your Low Rise Configuration. <br/> Floors 2-6 - 4,524 RSF.',
    }
  },

  mutations: {
    setFloor (state, payload) {
      state.floor = payload.floor
    },

    setConfiguration (state, payload) {
      state.configuration = payload.configuration
    },

    setFinish (state, payload) {
      state.finish = payload.finish
    },

    setHighRiseConfiguration (state, { zone, configuration }) {
      state.configurationHighRise[zone] = configuration
    },

    setMidRiseConfiguration (state, { zone, configuration }) {
      state.configurationMidRise[zone] = configuration
    },

    setLowRiseConfiguration (state, { zone, configuration }) {
      state.configurationLowRise = {
        ...state.configurationLowRise,
        [zone]: configuration
      }
    }
  },

  getters: {
    canSelectConfigure: ({ floor, floors }) => {
      return floors.indexOf(floor) >= 0;
    },

    canSelectYourDesign: ({ finish }) => {
      return !!finish;
    },

    highriseSelected: ({ floor }) => {
      return floor === 'highrise'
    },

    midriseSelected: ({ floor }) => {
      return floor === 'midrise'
    },

    lowriseSelected: ({ floor }) => {
      return floor === 'lowrise'
    },

    lightPaletteSelected: ({ finish }) => {
      return finish === 'light'
    },

    darkPaletteSelected: ({ finish }) => {
      return finish === 'dark'
    },

    zoneConfigurations: ({ floor, configurationLowRise, configurationMidRise, configurationHighRise }) => {
      let config = {}
      switch (floor) {
        case 'lowrise':
          config = configurationLowRise
          break;
        case 'midrise':
          config = configurationMidRise
          break;
        case 'highrise':
          config = configurationHighRise
          break;
        default:
          break;
      }
      return config
    },

    floorSummary: ({ floor, floorSummaries }) => {
      return floorSummaries[floor]
    }
  }
})

export default store
